/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Personal / Commercial License.
 * See LICENSE_PERSONAL / LICENSE_COMMERCIAL in the project root for license information on type of purchased license.
 */

import { Observable } from 'rxjs';

export interface User {
  id: number;
  fullName: string;
  firstName: string;
  lastName: string;
  login: string;
  email: string;
  age: number;
  userName: string;
  picture: string;
  address: Address;
  role: string;
  createdAt: Date;
}

export interface Address {
  street: string;
  city: string;
  zipCode: string;
}

export abstract class UserData {
  abstract getCurrentUserAdmin(): Observable<User>;
  abstract getAllUsersAdmin(): Observable<User[]>;
  abstract getAdmin(id: number): Observable<User>;
  abstract updateAdmin(user: User): Observable<User>;
  abstract updateCurrentAdmin(user: User): Observable<User>;
  abstract createAdmin(user: User): Observable<User>;
  abstract deleteAdmin(id: number): Observable<boolean>;

  abstract getCurrentUserApp(): Observable<User>;
  abstract getAllUsersApp(): Observable<User[]>;
  abstract getApp(id: number): Observable<User>;
  abstract updateApp(user: User): Observable<User>;
  abstract updateCurrentApp(user: User): Observable<User>;
  abstract createApp(user: User): Observable<User>;
  abstract deleteApp(id: number): Observable<boolean>;
}
